module.exports = __webpack_public_path__ + "static/media/real-estate-tips.48cf4a02.jpg";